import { render, staticRenderFns } from "./SGEventosOnline.vue?vue&type=template&id=c0793f48&scoped=true"
import script from "./SGEventosOnline.vue?vue&type=script&lang=js"
export * from "./SGEventosOnline.vue?vue&type=script&lang=js"
import style0 from "./SGEventosOnline.vue?vue&type=style&index=0&id=c0793f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0793f48",
  null
  
)

export default component.exports